import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { useNavigate } from 'react-router-dom';
import ExclamationIcon from 'icons/Exclamation.icon';
import { SELLING_PORTFOLIO_ROUTE } from 'data/global';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import {
  COLLEAGUE_ID,
  USER_ID,
} from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/components/PortfolioSellerFilters/data';

import './EnterpriseBanner.styles.scss';

type EnterpriseBannerProps = {
  className?: string;
};

const EnterpriseBanner: React.FC<EnterpriseBannerProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    currentUser: { _id },
  } = useContext(CurrentUserContext);

  const classes = classNames('enterprise-banner', className);

  return (
    <div className={classes}>
      <ExclamationIcon />

      <div>
        <span>{t('warningEnterpise')}</span>
        <span>{t('warningEnterpiseDisabled')}</span>
      </div>

      <Button
        variant="outline"
        onClick={() =>
          navigate(
            `${SELLING_PORTFOLIO_ROUTE}?${USER_ID}=${_id}&${COLLEAGUE_ID}=${_id}`,
          )
        }
      >
        {t('yourDeals')}
      </Button>
    </div>
  );
};

export default EnterpriseBanner;
